import { Component } from '@angular/core';

@Component({
  selector: 'app-invitation-invalid',
  templateUrl: './invitation-invalid.component.html'
})

export class InvitationInvalidComponent {}
